import { TFunction } from 'i18next';

export const PROMOTIONS_DISPLAY_LIMIT = 25;

export const GIVEAWAY_LIMIT = 10;
export const PROMOTION_DISCOUNT_LIMIT = 10;
export const PROMO_PRODUCTS_LIMIT = 10;
export const PROMO_CATEGORY_LIMIT = 10;
export const DISPLAY_COMPOSITE_IMAGE_SIZE = 50;

export const ActiveStatusOptions = (t: TFunction) => [
  { label: t('Active'), value: '1' },
  { label: t('Inactive'), value: '0' },
];
export const ActiveStatusOptionsFilter = (t: TFunction) => [
  { label: t('All'), value: '' },
  { label: t('Active'), value: '1' },
  { label: t('Inactive'), value: '0' },
];

export const DaysOptions = (t: TFunction) => [
  { label: t('Sunday'), key: 'sun' },
  { label: t('Monday'), key: 'mon' },
  { label: t('Tuesday'), key: 'tue' },
  { label: t('Wednesday'), key: 'wed' },
  { label: t('Thursday'), key: 'thu' },
  { label: t('Friday'), key: 'fri' },
  { label: t('Saturday'), key: 'sat' },
];

export const TypeConditionsOptions = (t: TFunction) => [
  // { label: t('All_products'), value: '3' },
  { label: t('P_Products'), value: '1' },
  { label: t('Categories'), value: '2' },
];
export const PeriodTypesOptions = (t: TFunction) => [
  { label: t('period_not_specify'), value: '1' },
  { label: t('period_specifiy'), value: '0' },
];
export const DiscountTypesOptions = (t: TFunction) => [
  { label: t('BahtDiscount'), value: '1' },
  { label: t('PercentageDiscount'), value: '2' },
];

export const PromoFreeCondUnitOptions = (t: TFunction) => [
  { label: t('Piece'), value: '1' },
  // { label: t('Qty'), value: '1' },
  { label: t('Baht'), value: '2' },
];
export const PromoFreeTypeOptions = (t: TFunction) => [
  { label: t('Item'), value: '1' },
  { label: t('Category'), value: '2' },
];

export const PromoTypes = (t: TFunction, showFreeGift: boolean) => [
  {
    options: [
      // { label: t('QuantityDiscount'), value: '1' },
      { label: t('ThresholdDiscount'), value: '2' },
      // { label: t('FixedPriceBundle'), value: '3' },
      ...(showFreeGift ? [{ label: t('FreeGiftPromotion'), value: '4' }] : []),
    ],
  },
];
export const FREE_GIFT_ALLOWED_STORE_IDS = [
  1072, 1146, 21497, 4010, 11234, 23930, 4010, 21020, 5327, 8315, 23489,
];

export const PromoTypesFilter = (t: TFunction, showFreeGift: boolean) => [
  {
    options: [
      { label: t('All'), value: '' },
      // { label: t('QuantityDiscount'), value: '1' },
      { label: t('ThresholdDiscount'), value: '2' },
      // { label: t('FixedPriceBundle'), value: '3' },
      ...(showFreeGift ? [{ label: t('FreeGiftPromotion'), value: '4' }] : []),
    ],
  },
];

export const PromotionButtonIconSize = '20px';
export const PromotionActionButtons = {
  button: {
    width: '30px',
    height: '30px',
  },
  icon: '20px',
};
